/**
* Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // $( '.ll-hero-banner__paws-group path' ).each( function( i, el ) {
      //   const number = $( '.ll-hero-banner__paws-group path' ).length - i;
      //   ScrollTrigger.create( {
      //     trigger: $( '.ll-hero-banner__paws-group path' )[number],
      //     start: 'top 75%',
      //     end: 'bottom 75%',
      //     scrub: true,
      //     markers: true,
      //     onToggle: ( {progress, direction, isActive} ) => {
      //       $( this ).css( {'opacity': 0.4} );
      //     },
      //   } );
      // } );

      ScrollTrigger.create( {
        trigger: $( '.ll-hero-banner' ),
        // start: '50% 75%',
        // end: 'bottom 75%',
        // markers: true,
        onRefresh: ( self ) => {
          if ( self.progress > 0 ) {
            $( '.ll-hero-banner__paws-group' ).addClass( 'animated' );
          }
        },
        onEnter: ( {progress, direction, isActive} ) => $( '.ll-hero-banner__paws-group' ).addClass( 'animated' ),
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hero-banner', COMPONENT );
} )( app );
